interface IProps {
  placement?: 'left' | 'right' | 'top' | 'bottom';
}

const DownChevronIcon = ({ placement = 'left' }: IProps) => {
  const obj = {
    left: 0,
    right: 180,
    bottom: 270,
    top: 90
  };

  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        transform: `rotate(${obj[placement]}deg)`
      }}
    >
      <path
        d="M3.76438 5.99434C3.76539 5.87882 3.81123 5.76821 3.89223 5.68584L8.25587 1.3222C8.33817 1.24271 8.44839 1.19873 8.56281 1.19972C8.67722 1.20072 8.78667 1.24661 8.86757 1.32751C8.94848 1.40842 8.99437 1.51787 8.99536 1.63228C8.99636 1.74669 8.95237 1.85692 8.87289 1.93922L4.81776 5.99435L8.87289 10.0495C8.91456 10.0897 8.94781 10.1379 8.97068 10.1911C8.99355 10.2444 9.00558 10.3016 9.00609 10.3596C9.00659 10.4175 8.99555 10.475 8.97361 10.5286C8.95167 10.5822 8.91927 10.6309 8.8783 10.6719C8.83732 10.7129 8.7886 10.7453 8.73498 10.7672C8.68135 10.7892 8.62389 10.8002 8.56595 10.7997C8.50801 10.7992 8.45075 10.7871 8.39751 10.7643C8.34427 10.7414 8.29612 10.7082 8.25587 10.6665L3.89223 6.30285C3.81123 6.22048 3.76539 6.10987 3.76438 5.99434Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default DownChevronIcon;
